const FORGET_PASSWORD_ACTION_TYPES = {
  FORGET_PASSWORD: 'FORGET_PASSWORD',
};

export default FORGET_PASSWORD_ACTION_TYPES;
